// Generated by scripts/build-info.mjs - do not edit, not committed.
export const BUILD_INFO = {
  sha: '4713fdfb80a5b19100fdd0a571a60ec86712f1ef',
  short: '4713fdf',
  builtAt: '2026-10-24T21:57:39.327Z',
} as const;
